
import { Options, Vue } from "vue-class-component";
import Input from "@/app/ui/components/input/index.vue";
import Toggle from "@/app/ui/components/toggle/index.vue";
import dateToTime from "@/app/infrastructures/misc/common-library/DateToTime";
import ellipsisString from "@/app/infrastructures/misc/common-library/EllipsisString";
import formatDate from "@/app/infrastructures/misc/common-library/FormatDate";
import formatDateNumber from "@/app/infrastructures/misc/common-library/FormatDateNumber";
import formatInputMoney from "@/app/infrastructures/misc/common-library/FormatInputMoney";
import formatInputMoneyWithDecimalV2 from "@/app/infrastructures/misc/common-library/FormatInputMoneyWithDecimalV2";
import dateToDateString from "@/app/infrastructures/misc/common-library/DateToDateString";
import { ExchangeRateController } from "@/app/ui/controllers/ExchangeRateController";
import { rateStatus } from "@/app/infrastructures/misc/common-library/ExchangeRate";

@Options({
  components: {
    Input,
    Toggle
  },
  beforeRouteLeave(to: any, from: any, next: any) {
    if (to.name === "login") {
      next();
    }
    if (!this.openSuccess) {
      this.onOpenClosePage(to);
      if (this.answer) {
        this.answer = false;
        next();
      } else {
        next(false);
      }
    } else {
      this.onCloseSuccess();
      next();
    }
  }
})
class Edit extends Vue {
  goBack() {
    this.$router.push(`/tarif/exchange-rate/${this.id}`);
  }

  get id(): number {
    return Number(this.$route.params.id);
  }

  disable = true;

  // Loading
  get isLoading() {
    return ExchangeRateController.isLoading;
  }

  // Handle Error
  get isError() {
    return ExchangeRateController.isError;
  }
  get isErrorEdit() {
    return ExchangeRateController.isErrorEdit;
  }
  handleErrorClose() {
    ExchangeRateController.setErrorEdit(false);
  }
  get errorCause() {
    return ExchangeRateController.errorCause;
  }

  // get data
  created() {
    this.getDetail();
  }

  getDetail() {
    ExchangeRateController.getDetailExchange({ id: this.id });
  }

  setRateStatus(status: "active" | "pending" | "inactive") {
    return rateStatus(status);
  }

  createdAt = "";
  createdBy = "";
  updatedAt = "";
  updatedBy = "";

  exchangeRateValue: any = 0;

  // Detail Data
  get detailData() {
    const detail = ExchangeRateController.exchangeRateDetail;
    this.createdAt = formatDate(detail.createdAt);
    this.createdBy = detail.createdBy;
    this.updatedAt =
      detail.updatedAt === "0001-01-01T00:00:00Z" || detail.updatedAt === null
        ? formatDate(detail.createdAt)
        : formatDate(detail.updatedAt);
    this.updatedBy = detail.updatedBy;
    this.exchangeRateValue = String(
      formatInputMoneyWithDecimalV2(detail.exchangeRate, 6, detail.exchangeRateTo)
    );
    this.effectiveDate = new Date(detail.effectiveDate);
    return detail;
  }

  // Decimal-aware formatting (supports up to 6 decimal digits, locale by
  // the pair's Kurs Tukar currency)
  formatted() {
    this.exchangeRateValue = formatInputMoneyWithDecimalV2(
      this.exchangeRateValue,
      6,
      this.detailData.exchangeRateTo
    );
  }

  get isRateValueInvalid() {
    const parsed = Number(
      formatInputMoneyWithDecimalV2(
        this.exchangeRateValue,
        6,
        this.detailData.exchangeRateTo,
        { reset: true }
      )
    );
    return !parsed || parsed <= 0;
  }

  get isDisabled() {
    return this.isRateValueInvalid || !this.effectiveDate;
  }

  // Modal Success
  get openSuccess() {
    return ExchangeRateController.openModalSuccess;
  }
  onCloseSuccess() {
    ExchangeRateController.setOpenModalSuccess(false);
  }

  // Save data
  onOpenSave() {
    return ExchangeRateController.setOpenModal(true);
  }
  get openSave() {
    return ExchangeRateController.openModal;
  }
  onCloseSave() {
    ExchangeRateController.setOpenModal(false);
  }
  _onEdit() {
    this.onCloseSave();
    ExchangeRateController._onEditExchange({
      id: Number(this.id),
      exchangeRate: Number(
        formatInputMoneyWithDecimalV2(
          this.exchangeRateValue,
          6,
          this.detailData.exchangeRateTo,
          { reset: true }
        )
      ),
      effectiveDate: formatDateNumber(this.effectiveDate)
    });
  }

  // Date
  effectiveDate: Date | null = null;
  get minDate() {
    const date = new Date();
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }
  inputEffectiveDate(param: Date) {
    this.effectiveDate = param;
  }

  // Close when changed
  isEditTerminated = false;
  newPath = "";
  answer = false;

  onOpenClosePage(to: any) {
    this.isEditTerminated = true;
    this.newPath = to.path;
  }

  handlerClose() {
    this.isEditTerminated = false;
    this.answer = true;
    this.$router.push(this.newPath);
  }

  handlerCancelClose() {
    this.answer = false;
    this.isEditTerminated = false;
  }

  // Ellipsis String
  ellipsisString(text: string) {
    return ellipsisString(text, 50);
  }

  // Object Format
  addObject = "";
  filterInputAddObject(e: any) {
    if (/^0/.test(e.target.value)) {
      e.target.value = e.target.value.replace(/^0/, "");
    } else {
      e.target.value = e.target.value.replace(/[\D]+/g, "");
      e.target.value = formatInputMoney(e.target.value);
    }
    this.addObject = e.target.value;
  }

  // Format Date
  formatDate(date: string) {
    return `${dateToDateString(new Date(date))} ${dateToTime(
      new Date(date)
    )} WIB`;
  }
}

export default Edit;
